import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../stores/useAppStore';
import { startOnboarding } from '../lib/onboarding';

/**
 * Watches for the "brand-new user" condition: bootstrap has completed,
 * a sync token is set, and there are zero universes. When that lines up,
 * creates a placeholder universe + onboarding chat and routes the user
 * into it. Fires at most once per mount.
 */
export default function OnboardingGuard() {
  const bootstrapStatus = useAppStore((s) => s.bootstrapStatus);
  const apiToken = useAppStore((s) => s.settings.apiToken);
  const universeCount = useAppStore((s) => Object.keys(s.universes).length);
  const nav = useNavigate();
  const triggered = useRef(false);

  useEffect(() => {
    if (triggered.current) return;
    if (bootstrapStatus !== 'ready') return;
    if (!apiToken) return;
    if (universeCount > 0) return;
    triggered.current = true;
    void (async () => {
      try {
        const { chatId } = await startOnboarding();
        nav(`/chat/${chatId}`, { replace: true });
      } catch (e) {
        console.warn('[onboarding] failed', e);
        triggered.current = false;
      }
    })();
  }, [bootstrapStatus, apiToken, universeCount, nav]);

  return null;
}
